// WPMS code
var feedbackBtn = {
    init: function () {
        this.feedbackScript = '#snl-feedback-script';
        this.buttonId = 'snl-feedback-button';
        this.storageName = 'useWpFeedback_wpThunderbirdTheme';
        this.kickOff();
    },
    kickOff: function () {

        // Perform check for dyanamic changes (hot swap) to feedback script.
        if (localStorage[this.storageName] === 'true' && $(this.feedbackScript).length > 0) {
            localStorage.setItem(this.storageName, 'false');
        } else if (localStorage[this.storageName] === 'false' && !$(this.feedbackScript).length) {
            localStorage.removeItem(this.storageName);
        }

        if (!localStorage.getItem(this.storageName)) {
            setTimeout(this.checkForFeedbackElem, 1200);
        } else if (localStorage[this.storageName] === 'false') {
            this.displayFeedbackButton();
        } else {
            $('#ux-feedback > a').show();
        }
    },
    displayFeedbackButton: function () {
        // Remove fallback feedback.
        $('.feedback-container .feedback').remove();

        if ($(this.feedbackScript).length > 0 && $(this.feedbackScript)[0].attributes["data-btn-ordinate"]) {

            // Check for UX style attr and then remove.
            var $this = this; // Preserve this in setInterval.
            var styleChecker = setInterval(function () {
                var styleAttr = $('#' + $this.buttonId + '.snl-feedback').attr('style');
                if (typeof styleAttr !== typeof undefined && styleAttr !== false) {
                    $('#' + $this.buttonId + '.snl-feedback').removeAttr('style');
                    $('#' + $this.buttonId + '.snl-feedback').removeClass('hide');
                    clearInterval(styleChecker);
                }
            }, 100);
        } else {
            $('#' + this.buttonId + '.snl-feedback').removeAttr('style');
            $('#' + this.buttonId + '.snl-feedback').removeClass('hide');
        }
    },
    checkForFeedbackElem: function () {
        // Preserve this inside of setTimeout.
        var $this = feedbackBtn;
        if ($($this.feedbackScript).length > 0) {
            $this.displayFeedbackButton();
            localStorage.setItem($this.storageName, 'false');
        } else {
            // Set session cookie so fallback feedback btn loads quicker.
            $('#ux-feedback > a').show();
            localStorage.setItem($this.storageName, 'true');
        }
    }
};

// Begin Document ready function.
$(function () {

    // Performs actions based on if ux.sandia.gov feedback is used.
    feedbackBtn.init();

    // Smooth scrolling when clicking on a hash link
    $('a[href^="#"]').on('click', function (e) {
        e.preventDefault();

        var target = $(this.hash);
        if (target.length) {
            $('html, body').animate({ scrollTop: target.offset().top }, 500);
        }
    });

    $('.card-content').hide();
    $('.card-header').click(function () {
        $(this).toggleClass('expanded').next('.card-content').slideToggle();
    });

    $('.panel-heading').on('click', function () {
        $(this).toggleClass('arrow-up');
    });

    //back to top sticky button
    $.fn.topLink = function (settings) {
        settings = $.extend({
            min: 1,
            fadeSpeed: 100
        },
            settings);

        return this.each(function () {
            //listen for scroll
            var el = $(this);
            el.hide(); //in case the user forgot
            $(window).scroll(function () {
                if ($(window).scrollTop() >= settings.min) {
                    el.fadeIn(settings.fadeSpeed);
                }
                else {
                    el.fadeOut(settings.fadeSpeed);
                }
            });
        });
    };

    $('<a style="display: inline;" id="back-to-top">Top</a>').prependTo($('body'));
    $('#back-to-top').topLink({
        min: 500,
        fadeSpeed: 100
    }
    );

    //smoothscroll
    $('#back-to-top').click(function () {
        $("html, body").animate({ scrollTop: 0 }, 300);
    });

    // Search box validation.
    $('body').on('click', 'a.search-submit', function () {
        $(this).closest('form').submit();
    });

    // Comments - for reply box interaction
    $('a.comment-reply-link').click(function () {
        $('#respond').addClass('add-comment');
    });
    $('a#cancel-comment-reply-link').click(function () {
        $('#respond').toggleClass('add-comment');
    });


    /* Start Fancy Box */
    $('main a:has(img)').each(function () {
        var _this = $(this);
        var hasFigureWrapper = _this.parents('figure').length;
        var anchorUrl = _this.attr('href');
        var urlExtension = anchorUrl ? anchorUrl.substr(anchorUrl.lastIndexOf('.') + 1) : '';
        var imageMatchesHref = $('img', _this).attr('src').indexOf(urlExtension) !== -1;
        var isAttachment = _this.attr('rel');

        if (!hasFigureWrapper && imageMatchesHref && !isAttachment) {
            _this.addClass('fancyBox');
            _this.closest('a').attr('data-fancybox');
        }
        else if (hasFigureWrapper && imageMatchesHref && !isAttachment) {
            var figCaptionText = _this.parent('figure').find('figcaption').text();

            _this.attr('data-caption', figCaptionText);
            _this.addClass('fancyBox');
            _this.closest('a').attr('data-fancybox');
        }
    });

    //Add clearfix to gallery items
    $('div.gallery').addClass('clearfix');
    //if is Gallery cover photo, remove fancybox
    $('a:has(h3,h4,h5)').closest('a').removeClass('fancyBox');

    //Fancy Box details
    var fancyWindow = $('.fancyBox');

    var fancyOptions = {
        buttons: [
            "zoom",
            "slideShow",
            "fullScreen",
            "download",
            "thumbs",
            "close"
        ],
        loop: true,
        transitionEffect: "fade",
        idleTime: 20,
        thumbs: {
            autoStart: true, // Display thumbnails on opening
            hideOnClose: true, // Hide thumbnail grid when closing animation starts
            parentEl: ".fancybox-container", // Container is injected into this element
            axis: "x" // Vertical (y) or horizontal (x) scrolling
        }
    };

    $(fancyWindow).fancybox(fancyOptions);

    /* End Fancy box */

    // Fa icons for links.
    $('a img').parent('a').addClass('no-icon');

    // Remvove external link icon for anchor tags
    $('a:not([href]):not([tabindex])').addClass('no-icon');

    // open/close all accordions
    $('.close-all').on('click', function () {
        $(this).closest('.accordion').find('.card').each(function () {
            $('.collapse', this).removeClass('show');
        });
    });

    $('.open-all').on('click', function () {
        $(this).closest('.accordion').find('.card').each(function () {
            $('.collapse', this).addClass('show');
        });
    });

});
// End Document ready

// GF remove-icon replacement
(function (root, $) {
    $(function () {
        if (typeof window.gform !== 'undefined') {
            window.gform.addFilter('gform_file_upload_markup', function (html, file, up, strings) {
                var formId = up.settings.multipart_params.form_id,
                    fieldId = up.settings.multipart_params.field_id;
                html = '<img class="gform_delete" ' +
                    "src=' " + window.location.origin + "/app/themes/wp-thunderbird-theme/img/icons/icons8-trash-24.png' " +
                    "onclick='gformDeleteUploadedFile(" + formId + "," + fieldId + ", this);' " +
                    "alt='" + strings.delete_file + "' title='" + strings.delete_file + "' style=\"margin-top: -5px;height: 18px;width: 18px;\"/>" +
                    ' <strong>' + file.name + '</strong>';
                return html;
            });
        }
    });
}(this, jQuery));

// Add blockquote class to blockquote tag
$(document).ready(function () {
    $('blockquote').addClass('blockquote');
    $('#back-to-top').removeClass('no-icon external-link');
});

// Hiding Open/Close All links on Accordion sections with a single accordion
$(function () {
    $(".accordion").each(function () {
        var n = $(this).children().length;
        if (n === 2) {
            $(this).first().find(">:first-child").css("visibility", "hidden");
        }
    });

});


// Open all accordions on pages referred from search results
$(function () {
    $(".accordion").each(function () {
        var refStr = document.referrer;
        var cp = window.location.href;
        var last = refStr.substring(refStr.lastIndexOf("/") + 1, refStr.length);
        var qc = last.substring(3, -1);
        var current = cp.substring(cp.lastIndexOf("/") + 1, cp.length);
        var pv = current.substring(3, -1);
        var comp = '?s='

        if (qc == comp && pv != comp) {
            $(this).closest('.accordion').find('.card').each(function () {
                $('.card-header', this).addClass('expanded');
                $('.collapse', this).addClass('show');
                $('.btn-link', this).removeClass('collapsed');
            });
        }
    });
});

// Hide icons on date field when no icon is chosen
$(document).ready(function () {
    $("input.datepicker_no_icon").parent('div').addClass('no_cal');
    $("div.clear-multi").parent('div').addClass('no_cal');
    $("div.gfield_date_year").addClass('no_cal');
    $("div.gfield_date_month").addClass('no_cal');
    $("div.gfield_date_day").addClass('no_cal');
});